module.exports = __webpack_public_path__ + "static/media/scratches@2x.bea836da.png";